import React, { useContext, useEffect, useRef, useState } from 'react'
import './QuestionBody.css'
import rightImg from '../../../assets/img/v2/right.png'
import wrongImg from '../../../assets/img/v2/wrong.png'
import rightAudio from '../../../assets/sound/right.wav'
import wrongAudio from '../../../assets/sound/wrong2.mp3'
import timesUpAudio from '../../../assets/sound/timesUp.mp3'
import timerAudio from '../../../assets/sound/timer.mp3'
import axios from 'axios'
import { baseUrl, dataContext, portal } from '../../../App'
import { useElapsedTime } from 'use-elapsed-time'
import { colorCleanUp, getServiceTypeFromEventId, secondsToMS, translateToBanglaNum } from './questionHelper'
import TimerBoxLinear from '../TimerBoxLinear/TimerBoxLinear'
import ProgressBar from '../ProgressBar/ProgressBar'
import activityLogSubmission from '../../../helper/activitylog'
import SingleOption from './SingleOption'
import clockImg from './assets/clock.png'
import logoImg from './assets/white_logo.png'
import rightCircle from './assets/right_circle.png'
import wrongCircle from './assets/wrong_circle.png'
import bottomImage from './assets/bottomImage.png'
import bottomSportsImage from './assets/bottomSports.png'
import styles from './QuestionBody.module.css'
// import CircularTimer from '../CircularTimer/CircularTimer'
import CircularTimer from '../../../components/CircularTimer/CircularTimer';
import { useNavigate } from 'react-router-dom'
import { FaHome, FaMedal } from 'react-icons/fa'



const QuestionBody = ({ eventDetails, finalScore, setFinalScore, setShowResultModal, playerRound, insertData , onDemandPurchaseTimes}) => {
  const { token, setToken, playerData, setPlayerData, events, setEvents } = useContext(dataContext);
  const isSubmitRef = useRef(false);
  // const [timerTick, setTimerTick] = useState(new Audio(timerAudio)) 
  const [allQuestions, setAllQuestions] = useState([])
  const [currentQues, setCurrentQues] = useState({})
  const [currentQuesIndex, setCurrentQuesIndex] = useState(null)
  const [isLoadingEnd, setIsLoadingEnd] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [totalRightAnswer, setTotalRightAnswer] = useState(0)
  const [totalWrongAnswer, setTotalWrongAnswer] = useState(0)
  const [timerWidth, setTimerWidth] = useState(100)
  const [progressWidth, setProgressWidth] = useState(0)
  const [singleTimerWidth, setsingleTimerWidth] = useState(100)
  const [timerTime, setTimerTime] = useState(0)
  const [singleTime, setSingleTime] = useState(6)
  const [isPlaying, setIsPlaying] = useState(false);
  const { elapsedTime } = useElapsedTime({ isPlaying });
  const navigate = useNavigate();

  const [singleTimerLower, setSingleTimerLower] = useState(0.0)

  const tickingElm = useRef(0);
  const totalRightScoreRef = useRef(0);
  const totalWrongScoreRef = useRef(0);
  const submissionLockRef = useRef(false);
  const startTimeRef = useRef(null);
  const actionTraceRef = useRef([]);
  useEffect(() => {
    axios.get(`${baseUrl}/api/questions/?rules=${eventDetails.id}&portal=${portal}&ondemand=${onDemandPurchaseTimes}`, {
      headers: { Authorization: `Token ${token}` }
    })
      .then(response => {
        setAllQuestions(response.data)
        setIsLoadingEnd(true)
        setCurrentQuesIndex(0)
        startTimeRef.current = Date.now();
        submissionLockRef.current = false;
        actionTraceRef.current = [];
        submitBatchRecord([], 0);
        let totalTime = eventDetails.allocated_time;
        let tempSingleTime = totalTime / response.data.length;
        setSingleTime(tempSingleTime)
        // console.log(totalTime)
        setTimerTime(totalTime)
        tickingElm.current = new Audio(timerAudio)
        tickingElm.current.play()
        tickingElm.current.loop = true;

        // timerTick.load()
        // timerTick.play()
        // timerTick.loop = true
      })
  }, [])


  useEffect(() => {
    setFinalScore(totalRightAnswer)
  }, [totalRightAnswer])

  // timerCode
  // let timerTime = eventDetails.allocated_time;
  let remainingWidth = (((timerTime - elapsedTime) / timerTime) * 100).toFixed(2);
  let remainingTime = (((timerTime - elapsedTime))).toFixed(2);

  useEffect(() => {
    setTimerWidth(remainingWidth)
  }, [remainingWidth])

  if (elapsedTime > timerTime) {
    if (isPlaying) {
      setIsPlaying(false)
      gameDone()
    }
  }

  // singleTimer with event time / question no
  let tempTime = (eventDetails?.allocated_time) || 6;
  let tempQuesLenght = (allQuestions?.length) || 1;

  // let singleTime = (tempTime / tempQuesLenght);
  let singleTimerUpper = singleTime + singleTimerLower;
  let singleTimerRemaining = (((singleTimerUpper - elapsedTime) / singleTime) * 100).toFixed(2);
  useEffect(() => {
    setsingleTimerWidth(singleTimerRemaining)
  }, [singleTimerRemaining])
  // if (singleTimerUpper <= elapsedTime) {
  //   if (isPlaying && (!isSubmitted)) {
  //     setIsPlaying(false)
  //     new Audio(timesUpAudio).play();
  //     singleTimerSubmit()
  //   }
  // }
  // Timer Done

  useEffect(() => {
    let msisdn = null;

    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission(`events-${eventDetails.id}`, msisdn);
  }, [])

  // Loading: [Done]
  useEffect(() => {
    if (isLoadingEnd) {
      setCurrentQues(allQuestions[currentQuesIndex])
      setIsPlaying(true)
      setSingleTimerLower(parseFloat(elapsedTime.toFixed(1)))
      // setSingleTime(allQuestions[currentQuesIndex].time_allocated)
      // setSingleTime((allQuestions[currentQuesIndex]?.time_allocated) ? allQuestions[currentQuesIndex].time_allocated : 6)
    }

    let progress = allQuestions.length ? ((currentQuesIndex) ? ((currentQuesIndex) / allQuestions.length) : 0) : 0;
    setProgressWidth((progress * 100).toFixed(2))

    if (currentQuesIndex === 20) {
      submitBatchRecord(allQuestions.slice(0, 20).map(q => q.id), Math.floor(elapsedTime));
    }
    if (currentQuesIndex === 40) {
      submitBatchRecord(allQuestions.map(q => q.id), Math.floor(elapsedTime));
    }
  }, [currentQuesIndex])

  useEffect(() => {
    return () => {
      tickingElm.current.pause()
      console.log("in cleanup")
    }
  }, [])

  // console.log(allQuestions)
  function handleAnswerClick(event, answerId) {
    if (isSubmitRef.current) return;
    isSubmitRef.current = true;
    setIsSubmitted(true)

    let isRight = 0;
    let mobile = playerData.msisdn;
    let round = playerRound + 1;
    let questionId = currentQues.id;
    let selectedAns = `Option${answerId}`;
    let category = currentQues.category;
    let totalRightScore = totalRightAnswer;

    if (parseInt((currentQues.ans.trim()).slice(-1)) === answerId) {
      event.currentTarget.classList.add('bg_right')
      new Audio(rightAudio).play();
      totalRightScore = totalRightAnswer + 1;
      sessionStorage.setItem('quizPlay_totalRightScore', totalRightScore);
      setTotalRightAnswer((totalRightAnswer + 1));
      totalRightScoreRef.current++;
      actionTraceRef.current.push({ q: questionId, a: selectedAns, r: 1, t: Math.floor(elapsedTime) });
      isRight = 1;
    } else {
      event.currentTarget.classList.add('bg_wrong')
      totalWrongScoreRef.current++;
      new Audio(wrongAudio).play()
      let totalWrongScore = totalWrongAnswer + 1;
      sessionStorage.setItem('quizPlay_totalWrongScore', totalWrongScore);
      setTotalWrongAnswer((totalWrongAnswer + 1))
      actionTraceRef.current.push({ q: questionId, a: selectedAns, r: 0, t: Math.floor(elapsedTime) });
    }
    // insertData(isRight, mobile, round, questionId, selectedAns, category, eventDetails.id, onDemandPurchaseTimes);
    console.log(totalRightScore);
    updateLocalLeaderboard(eventDetails.id, playerRound + 1, totalRightScore, Math.floor(elapsedTime));
    
    if (currentQuesIndex < (allQuestions.length - 1)) {
      setTimeout(() => {
        setIsPlaying(false)
        colorCleanUp('singleOptions')
        setCurrentQuesIndex((currentQuesIndex + 1))
        setIsSubmitted(false)
        isSubmitRef.current = false;
      }, 400);
    } else {
      gameDone()
    }
  }

  function submitBatchRecord(roundQuestions, timeTaken) {
    axios.post(`${baseUrl}/api/participant/quizplay_record`, {
      msisdn: playerData?.msisdn,
      category: null,
      time_taken: timeTaken,
      round_number: playerRound + 1,
      event: eventDetails?.id,
      right_count: totalRightScoreRef.current,
      question_count: totalRightScoreRef.current + totalWrongScoreRef.current,
      serviceType: getServiceTypeFromEventId(eventDetails?.id),
      portal: 15,
      round_questions: roundQuestions
    }, {
      headers: { Authorization: `Token ${token}` }
    }).catch(e => console.log("Batch record failed:", e));
  }

  function submitFinalScore(){
    if (submissionLockRef.current) return;
    submissionLockRef.current = true;

    let totalTimeTakenIntegrity = 0;
    if (startTimeRef.current) {
      totalTimeTakenIntegrity = Math.floor((Date.now() - startTimeRef.current) / 1000);
    }
    // Wall clock is authoritative, but never report less than the quiz timer or more than the event allows
    let maxTime = eventDetails?.allocated_time || 180;
    let finalTimeTaken = Math.min(Math.max(totalTimeTakenIntegrity, Math.floor(elapsedTime)), maxTime);

    axios.post(`${baseUrl}/api/participant/quizplay_summery_submission`, {
      // user: playerData?.id,
      msisdn: playerData?.msisdn,
      category: null,
      time_taken: finalTimeTaken,
      round_number: playerRound + 1,
      event: eventDetails?.id,
      right_count: totalRightScoreRef.current,
      question_count: totalRightScoreRef.current + totalWrongScoreRef.current,
      serviceType: getServiceTypeFromEventId(eventDetails?.id),
      portal: 15,
      round_questions: actionTraceRef.current.map(item => item.q)
    }, {
      headers: { Authorization: `Token ${token}` }
    });
    activityLogSubmission(`events-${eventDetails.id}-end-score-${totalRightScoreRef.current}`)
  }

  function gameDone() {
    console.log(totalRightScoreRef.current, totalWrongScoreRef.current);
    submitFinalScore()
    sessionStorage.setItem('quizPlay_eventId', eventDetails.id);
    sessionStorage.setItem('quizPlay_passingScore', eventDetails.passing_score);
    // Update leaderboard in localStorage
    updateLocalLeaderboard(eventDetails.id, playerRound + 1, totalRightAnswer, Math.floor(elapsedTime));
    tickingElm.current.pause()
    setIsPlaying(false)
    setProgressWidth('100')
    if(eventDetails.id === 145){
      navigate(`../?page=trialPage`)
    }else{
      navigate(`../?page=result&eventId=${eventDetails.id}`)
    }
  }


  // Helper function to update leaderboard in localStorage
  function updateLocalLeaderboard(eventId, roundNumber, score, totalTime) {
    try {
      // Get existing leaderboard data from localStorage
      const existingData = localStorage.getItem('quizLeaderboard');
      let leaderboardArray = existingData ? JSON.parse(existingData) : [];
      
      // Check if entry with same event_id already exists
      const existingIndex = leaderboardArray.findIndex(entry => entry.event_id === eventId);
      
      const newEntry = {
        event_id: eventId,
        round_number: roundNumber,
        score: score,
        totalTime: totalTime,
        updateTime: new Date().toISOString()
      };
      
      if (existingIndex !== -1) {
        // Update existing entry
        leaderboardArray[existingIndex] = newEntry;
      } else {
        // Add new entry
        leaderboardArray.push(newEntry);
      }
      
      // Save updated array back to localStorage
      localStorage.setItem('quizLeaderboard', JSON.stringify(leaderboardArray));
      
      console.log('Leaderboard updated:', newEntry);
    } catch (error) {
      console.error('Error updating leaderboard:', error);
    }
  }

  return (
    <>
      <div className={styles.quizNavbar}>
        <div className={styles.timerSection}>
          <div className={styles.timeRemaining}>
            <img src={clockImg} style={{ height: '18px' }} alt="Clock" className={styles.clock} />
            <span>{translateToBanglaNum(secondsToMS(parseFloat((remainingTime < 0) ? '0' : remainingTime)))}</span>
          </div>
          <img src={logoImg} alt="Logo" className={styles.logo} />
          <div className={styles.questionCounter}><span>প্রশ্ন:</span>
            <span>{translateToBanglaNum((currentQuesIndex + 1).toString())}/{translateToBanglaNum(allQuestions.length.toString())}</span>
          </div>
        </div>
        <div className={styles.progressBarSection}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill} style={{ width: `${progressWidth}%` }}></div>
          </div>
        </div>
      </div>
      <div className={styles.iconContainer} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 18px 5px 16px' }}>
        <div onClick={() => {
          tickingElm.current.pause();
          navigate('../?page=home');
        }} style={{ cursor: 'pointer' }}>
          <FaHome size={24} color="#270D6F" />
        </div>
        <div onClick={() => {
          sessionStorage.setItem('leaderEventId', eventDetails.id);
          tickingElm.current.pause();
          navigate('../?page=leader')}} style={{ cursor: 'pointer' }}>
          <FaMedal size={24} color="#270D6F" />
        </div>
      </div>
      <div className={styles.scoreContainer}>
        <div className={styles.scoreItem}>
          <img src={rightCircle} alt="" style={{ height: '18px' }} className={styles.scoreRightCircle} />
          <span>{translateToBanglaNum(totalRightAnswer.toString())}</span>
        </div>
        <div className={styles.circularTimeRemaining} style={{opacity: '0'}}>
          <CircularTimer progress={parseFloat(singleTimerWidth)} />
        </div>

        <div className={styles.scoreItem}>
          <img src={wrongCircle} alt="" style={{ height: '18px' }} className={styles.scoreRightCircle} />
          <span>{translateToBanglaNum(totalWrongAnswer.toString())}</span>
        </div>
      </div>

      <div className={styles.questionBoxWrapper}>
        <div className={styles.questionField}>
          {currentQues?.question}
        </div>
        <div className={styles.optionsField}>
          <SingleOption props={{ currentQues, handleAnswerClick, currentQuesIndex }}></SingleOption>
        </div>
      </div>
      <img src={(eventDetails.id === 75) ? bottomSportsImage : bottomImage} alt="" className={styles.bottomImage} />
      {/* <div className="questionBox">

        <div className="questionFieldOuter">
          <div className="circle1"></div>
          <div className="circle2"></div>
          <div className="questionFieldWrapper">
            <div className="questionField">
              {currentQues?.question}
            </div>
          </div>
        </div>
        <div className="optionsWrapper">
          <div className="optionsField">
            <SingleOption props={{ currentQues, handleAnswerClick, currentQuesIndex }}></SingleOption>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default QuestionBody